import { compareAsc, compareDesc } from 'date-fns';

import { Item } from '../../core';
import { OrderBy } from '../model/order-by.model';

export function sortItems(orderBy: OrderBy, items: Item[]): Item[] {
    switch (orderBy) {
        case OrderBy.DATE_DESC:
            return [...items].sort((a, b) =>
                compareDesc(a.timestamp, b.timestamp),
            );
        case OrderBy.DATE_ASC:
            return [...items].sort((a, b) =>
                compareAsc(a.timestamp, b.timestamp),
            );
        case OrderBy.USERNAME_ASC:
            return [...items].sort((a, b) => a.title.localeCompare(b.title));
        case OrderBy.USERNAME_DESC:
            return [...items].sort((a, b) => b.title.localeCompare(a.title));
        default:
            return items;
    }
}
